import React, { useState, useEffect, useContext } from 'react';
import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';
import Typography from '@mui/material/Typography';
import PieChart from '@mui/icons-material/PieChart';

import Grid from '@mui/material/Grid';
import Item from '@mui/material/Grid';
import Box from '@mui/material/Box';

import StatusChart from 'components/StatusChart/StatusChart';

import 'i18n/config';
import { useTranslation } from 'react-i18next';
import { DataContext } from 'contexts/DataContext';
import AssessmentNavigator from 'components/AssessmentNavigator/AssessmentNavigator';
import RiskChart from 'pages/Strategy/RiskChart';
import { assessmentRisk } from 'components/ExecutiveView/api';

function Status() {
  const {t} = useTranslation();
  const [maxAssessmentsRisks, setMaxAssessmentsRisks] = useState(false as any);
  const dataContext = useContext(DataContext);

  useEffect(()=>{ 
    if(dataContext.loading) return;
    if(!dataContext.currentOrganization) return;
    dataContext.changeShowLoader(true);

    assessmentRisk(dataContext.currentOrganization, dataContext.currentAssessment).then(response=>{
      let maxAssessmentsRisks = Math.max(...response.map((o:any) => o.risk_detail));
      maxAssessmentsRisks = maxAssessmentsRisks < 0 ? 0 : maxAssessmentsRisks;
      setMaxAssessmentsRisks(maxAssessmentsRisks);
      dataContext.changeShowLoader(false);
    });

  },[dataContext.loading, dataContext.currentOrganization, dataContext.currentAssessment])

  return (
<AppLayout drawerOpen={true} drawer={<AppDrawer />} 
        title={<><Typography variant='pageTitle'>{t('Status')}</Typography></>}>
        <Grid container spacing={2}>
            <Grid item xs={7}>
                <Item>
                  <Box sx={{display:'flex', flexDirection:'row', justifyContent:'center', marginTop:5}}>
                  <StatusChart />
                  </Box>

                  <Box sx={{display:'flex', flexDirection:'row', justifyContent:'center'}}>

                  {maxAssessmentsRisks!==false && 
                    <RiskChart name="maxRisk" value={maxAssessmentsRisks} />}
                  </Box>


                </Item>
            </Grid>

            <Grid item xs={5}>
                <Item>
                  <AssessmentNavigator currentCategory='' currentSubcategory='' selectCategory={()=>{}} selectSubcategory={()=>{}} />
                </Item>
            </Grid>

           
        </Grid>

    </AppLayout>
  );
}

export default Status;
